// DS: i3.2
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const Add = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M14.035 7.985a1 1 0 01-1 1h-4v4.1a1 1 0 01-.874.993l-.126.008a1 1 0 01-.993-.884l-.007-.116V8.985h-4a1 1 0 110-2l4-.001V3.086a1 1 0 01.875-.993l.125-.007a1 1 0 01.993.883l.007.117v3.898l4 .001a1 1 0 011 1z",
        clipRule: "evenodd"
    })));
};
Add.displayName = 'Add';
export default Add;
